import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import { requireFeatureFlag } from 'lib/routeGuards'

import LoginChallenge from 'pages/LoginChallenge'

const loginChallengeSearchSchema = z.object({
  lat: z.coerce.number().optional(),
  lng: z.coerce.number().optional(),
})

export const Route = createFileRoute('/public/challenge')({
  beforeLoad: requireFeatureFlag('challenges'),
  component: LoginChallenge,
  validateSearch: zodValidator(loginChallengeSearchSchema),
})
